module.exports = __webpack_public_path__ + "img/lattes-cinza.db247ed4.png";